import React from 'react';
import { button } from 'react-validation';

import { Button } from '../styled';

const SubmitButton = ({ hasErrors, formValid, disabled, ...props }) => <Button {...props} disabled={hasErrors || !formValid || disabled} />;

export default button(SubmitButton);
